<template>
  <div class="layout_aside full-height" v-loading.lock="isAsideLoading">
    <div class="aside-top flex flex-middle flex-between" v-height="50">
      <span style="min-width:190px; font-size: 14px; padding-left: 6px;">实例：{{instanceName}}</span>
      <el-button size="mini" icon="el-icon-refresh" @click="onRefresh"></el-button>
    </div>
    <!-- start: panel -->
    <!--<div class="panel flex flex-middle flex-between" v-height="42">
      <el-button size="mini" type="primary" @click="onCreateDatabase">新建数据库</el-button>
      <el-button size="mini" icon="el-icon-refresh" @click="onRefresh"></el-button>
    </div>-->
    <!-- end: panel -->

    <!-- start: tree -->
    <div class="tree-wrapper" v-height="$store.state.size.heightHomeMain - 50"
         @contextmenu.prevent>
      <!-- @node-click="handleNodeClick"-->
      <el-tree
        ref="tree"
        class="tree el-tree-highlighter"
        node-key="id"
        icon-class="hidden"
        :data="treeData"
        :props="{ label: 'label', children: 'children', disabled: 'disabled', isLeaf: 'isLeaf' }"
      >
        <template #default="{ node, data }">
          <tree-node
            v-if="data.belong === 'DATABASE'"
            :node="node"
          ></tree-node>
          <tree-node
            v-else-if="data.belong === 'COLLECTIONS'"
            :node="node"
          ></tree-node>
          <tree-node
            v-else-if="data.belong === 'COLLECTION'"
            :node="node"
          ></tree-node>
          <tree-node
            v-else-if="data.belong === 'INDEXES'"
            :node="node"
          ></tree-node>
          <tree-node
            v-else-if="data.belong === 'INDEX'"
            :node="node"
          ></tree-node>
          <tree-node
            v-else-if="data.belong === 'USERS'"
            :node="node"
          ></tree-node>
          <tree-node
            v-else-if="data.belong === 'USER'"
            :node="node"
          ></tree-node>
          <span v-else>未知节点</span>
        </template>
      </el-tree>
    </div>
    <!-- end: tree -->

    <!-- start: database creator -->
    <database-creator ref="databaseCreator" @submit="handleDatabaseCreated"></database-creator>
    <!-- end: database creator -->
  </div>
</template>

<script>
import { reqFetchDatabases } from '@/api/mongodb';
import TreeNode from '@/views/common/TreeNode';
import DatabaseCreator from './features/DatabaseCreator';
import Store from '@/store/';

/**
 * 数据库的树节点
 * id: 节点的 id
 * name: 数据库名称
 * type: 数据库类型。[system, user]
 */
class ITreeNodeDatabase {
  constructor({ id, databaseName, collections, users }) {
    this.id = id;
    this.databaseName = databaseName;
    this.label = this.databaseName;
    this.isLeaf = false;
    this.belong = 'DATABASE';
    this.logo = 'database';
    this.logoSize = 18;
    this.children = [
      new ITreeNodeCollections({
        databaseNodeId: id,
        databaseName: databaseName,
        collections: collections
      }),
      new ITreeNodeUsers({
        databaseNodeId: id,
        databaseName: databaseName,
        users: users
      })];
  }
}

/**
 * 数据库拥有的集合 树节点
 */
class ITreeNodeCollections {
  constructor({ databaseNodeId, databaseName, collections }) {
    this.id = `${databaseNodeId}_0`;
    this.label = `集合 (${collections.length})`;
    this.isLeaf = collections.length <= 0;
    this.belong = 'COLLECTIONS';
    this.databaseName = databaseName;
    this.logo = 'menu';
    this.logoSize = 15;
    this.children = collections.map(
      (collection, index) =>
        new ITreeNodeCollection({
          id: `${this.id}_${index}`,
          databaseName: this.databaseName,
          collectionName: collection.ColName,
          indexs: collection.IndexName ? collection.IndexName : []
        })
    );
  }
}

/**
 * 数据库拥有的用户 树节点
 */
class ITreeNodeUsers {
  constructor({ databaseNodeId, databaseName, users }) {
    this.id = `${databaseNodeId}_1`;
    this.label = `用户 (${users.length})`;
    this.isLeaf = users.length <= 0;
    this.belong = 'USERS';
    this.databaseName = databaseName;
    this.logo = 'users';
    this.logoSize = 18;
    this.children = users.map(
      (user, index) =>
        new ITreeNodeUser({
          id: `${this.id}_${index}`,
          username: user,
          databaseName: databaseName,
        })
    );
  }
}

/**
 * 集合 树节点
 */
class ITreeNodeCollection {
  constructor({ id, databaseName, collectionName, indexs }) {
    this.id = id;
    this.databaseName = databaseName;
    this.collectionName = collectionName;
    this.label = collectionName;
    this.belong = 'COLLECTION';
    this.isLeaf = false;
    this.children = [
      new ITreeNodeCollectionIndexes({
        collectionId: id,
        collectionName: collectionName,
        databaseName: databaseName,
        indexes: indexs
      })];
    this.logo = 'menu-2';
    this.logoSize = 15;
  }
}

/**
 * 用户 树节点
 */
class ITreeNodeUser {
  constructor({ id, username, databaseName, roles }) {
    this.id = id;
    this.label = username;
    this.isLeaf = true;
    this.belong = 'USER';
    this.username = username;
    this.databaseName = databaseName;
    this.logo = 'user';
    this.logoSize = 16;
  }
}

/**
 * 集合的索引集
 */
class ITreeNodeCollectionIndexes {
  constructor({ collectionId, databaseName, collectionName, indexes }) {
    this.id = `${collectionId}_0`;
    this.label = `索引 (${indexes.length})`;
    this.isLeaf = indexes.length <= 0;
    this.belong = 'INDEXES';
    this.collectionName = collectionName;
    this.databaseName = databaseName;
    this.logo = 'key-2';
    this.logoSize = 16;
    this.children = indexes.map(
      (indexInfo, index) =>
        new ITreeNodeIndex({
          id: `${collectionId}_0_${index}`,
          parentId: this.id,
          indexName: indexInfo,
          key: indexInfo,
          collectionName,
          databaseName
        })
    );
  }
}

/**
 * 集合的索引
 */
class ITreeNodeIndex {
  constructor({ id, key, collectionName, indexName, databaseName }) {
    this.id = id;
    this.label = indexName;
    this.indexName = indexName;
    this.collectionName = collectionName;
    this.key = { ...key };
    this.belong = 'INDEX';
    this.isLeaf = true;
    this.databaseName = databaseName;
    this.logo = indexName === '_id_' ? 'key-primary' : 'document';
    this.logoSize = 17;
  }
}

export default {
  name: 'LayoutAside',

  components: {
    TreeNode,
    DatabaseCreator
  },

  data() {
    return {
      isAsideLoading: false,
      treeData: [],
      instanceName: ''
    };
  },

  computed: {
    currentTreeNodeData() {
      return this.$refs.tree ? this.$refs.tree.getCurrentNode() : null;
    }
  },

  created() {
    this.instanceName = Store.state.source.sourceInfo.instanceName;
    this.getDatabases();
  },

  methods: {
    /**
     * =============================================================
     * 侧边栏
     * =============================================================
     */
    /**
     * 渲染侧边栏的数据库节点
     */
    async getDatabases() {
      this.isAsideLoading = true;
      try{
        const res = await reqFetchDatabases();
        this.treeData = res.data.data.map((item, index) => {
          return new ITreeNodeDatabase({
            id: `1_${index}`,
            databaseName: item.DbName,
            collections: item.Collections ? item.Collections : [],
            users: item.Users ? item.Users : []
          })
        })
        if (this.treeData.length === 0) {
          this.$message.error('当前角色没有可用的数据库');
          return;
        }
        this.isAsideLoading = false;
      } catch (e) {
        this.$message.error('获取数据库失败');
        this.isAsideLoading = false;
      }

    },
    /**
     * 刷新侧边栏
     */
    onRefresh() {
      this.getDatabases();
    },
    /**
     * 创建数据库
     */
    onCreateDatabase() {
      this.$refs.databaseCreator.open();
    },
    handleDatabaseCreated(result) {
      if (result) {
        this.$refs.aside.getDatabases();
      }
    },
  }
};
</script>

<style scoped lang="scss">
// $height-tree-node: 22px;

.layout_aside {
  width: 100%;
  background-color: #fff;

  .aside-top{
    background-color: #e4e7ed;
    padding-left: 4px;
    padding-right: 4px;
  }

  .panel {
    border-bottom: 1px solid #eee;
    padding-left: 12px;
    padding-right: 12px;

    &-label {
      font-size: 15px;
    }
  }

  .tree-wrapper {
    padding-top: 12px;
    padding-bottom: 12px;
    max-width: 100%;
    overflow: auto;

    .tree {
      // 神器的代码。加上就可以出现滚动条
      height: 100%;
      min-width: 100%;
      display: inline-block;

      &::v-deep .el-tree-node {
        .el-tree-node__content {
          // height: $height-tree-node !important;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>
